<!--<app-login-header></app-login-header>-->

<!--<div class="container-fluid login-wrapper p-0">-->
<!--  <div class="page-content p-0">-->
<!--    <div class="content-wrapper p-3">-->
<!--      <div>-->
<!--        <h5>DJB STP's</h5>-->
<!--        <hr>-->
<!--        <div class="row g-3">-->
<!--          &lt;!&ndash; STP: Total Connected &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3" *ngIf="cardDetail">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total No. of STPs of DJB connected on CEMS</h6>-->
<!--                  <strong style="font-size: 40px; color: #86CE6D;">{{ totalSTP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/2.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; STP: Meeting Standards &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of STPs meeting prescribed Standards</h6>-->
<!--                  <strong style="font-size: 40px; color: #119DF3;">{{ meetingSTP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/7.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; STP: Not Meeting Standards &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of STPs not meeting prescribed Standards</h6>-->
<!--                  <strong style="font-size: 40px; color: #FB6058;">{{ exceedSTP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/8.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; STP: Offline &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of STPs where CEMS is offline/Not functioning</h6>-->
<!--                  <strong style="font-size: 40px; color: #814EC1;">{{ closeSTP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/3.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--&lt;!&ndash;          STP: Total waste water treated&ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total Waste Water treated through STPs of DJB (in MLD)-->
<!--                  </h6>-->
<!--                  <strong style="font-size: 40px; color: #814EC1;">{{ waterSTP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/3.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; CETPs Section &ndash;&gt;-->
<!--      <div>-->
<!--        <h5 class="mt-5">DJB CETP's</h5>-->
<!--        <hr>-->
<!--        <div class="row g-3">-->
<!--          &lt;!&ndash; CETP: Total Connected &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total No. of CETPs connected on CEMS</h6>-->
<!--                  <strong style="font-size: 40px; color: #86CE6D;">{{ totalCETP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/6.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; CETP: Meeting Standards &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of CETPs meeting prescribed Standards</h6>-->
<!--                  <strong style="font-size: 40px; color: #119DF3;">{{ meetingCETP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/7.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; CETP: Not Meeting Standards &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of CETPs not meeting prescribed Standards</h6>-->
<!--                  <strong style="font-size: 40px; color: #FB6058;">{{ exceedCETP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/8.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; CETP: Offline &ndash;&gt;-->
<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of CETPs where CEMS is offline/Not functioning</h6>-->
<!--                  <strong style="font-size: 40px; color: #814EC1;">{{ closeCETP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/3.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="card card-list-item h-100">-->
<!--              <div class="card-body d-flex align-items-start">-->
<!--                <div class="flex-grow-1 me-3">-->
<!--                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total Waste Water treated through STPs of DJB (in MLD)-->
<!--                  </h6>-->
<!--                  <strong style="font-size: 40px; color: #814EC1;">{{ waterCETP }}</strong>-->
<!--                </div>-->
<!--                <div class="flex-shrink-0">-->
<!--                  <img src="/assets/images/icons/3.png">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<!--&lt;!&ndash; Your existing content &ndash;&gt;-->

<!--&lt;!&ndash; Pie Charts Section &ndash;&gt;-->
<!--<div class="row mt-4" *ngIf="graphPlot">-->
<!--  <div class="col-md-6">-->
<!--    <h6 class="fw-semibold">STP Pie Chart</h6>-->
<!--    <div [chart]="stpPieChart" style="height: 350px; min-width: 310px;"></div>-->
<!--  </div>-->
<!--  <div class="col-md-6">-->
<!--    <h6 class="fw-semibold">CETP Pie Chart</h6>-->
<!--    <div [chart]="cetpPieChart" style="height: 350px; min-width: 310px;"></div>-->
<!--  </div>-->
<!--</div>-->

<!--<app-footer></app-footer>-->
<app-login-header></app-login-header>

<div class="page-container login-wrapper p-0">
  <div class="page-content p-0">
    <div class="content-wrapper p-3">
      <!-- STP Section -->
      <div>
        <h5>DJB STP's</h5>
        <hr>
        <div class="row g-3">
          <!-- STP: Total Connected -->
          <div class="col-sm-6 col-md-4 col-lg-2-4" *ngIf="cardDetail">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total No. of STPs of DJB connected on CEMS</h6>
                  <strong style="font-size: 40px; color: #86CE6D;">{{ totalSTP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/2.png">
                </div>
              </div>
            </div>
          </div>

          <!-- STP: Meeting Standards -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of STPs meeting prescribed Standards</h6>
                  <strong style="font-size: 40px; color: #119DF3;">{{ meetingSTP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/7.png">
                </div>
              </div>
            </div>
          </div>

          <!-- STP: Not Meeting Standards -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of STPs not meeting prescribed Standards</h6>
                  <strong style="font-size: 40px; color: #FB6058;">{{ exceedSTP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/8.png">
                </div>
              </div>
            </div>
          </div>

          <!-- STP: Offline -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of STPs where CEMS is offline/Not functioning</h6>
                  <strong style="font-size: 40px; color: #814EC1;">{{ closeSTP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/3.png">
                </div>
              </div>
            </div>
          </div>

          <!-- STP: Total waste water treated -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total Waste Water treated through STPs of DJB (in MLD)</h6>
                  <strong style="font-size: 40px; color: #814EC1;">{{ waterSTP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/3.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CETPs Section -->
      <div>
        <h5 class="mt-5">DJB CETP's</h5>
        <hr>
        <div class="row g-3">
          <!-- CETP: Total Connected -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total No. of CETPs connected on CEMS</h6>
                  <strong style="font-size: 40px; color: #86CE6D;">{{ totalCETP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/6.png">
                </div>
              </div>
            </div>
          </div>

          <!-- CETP: Meeting Standards -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of CETPs meeting prescribed Standards</h6>
                  <strong style="font-size: 40px; color: #119DF3;">{{ meetingCETP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/7.png">
                </div>
              </div>
            </div>
          </div>

          <!-- CETP: Not Meeting Standards -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of CETPs not meeting prescribed Standards</h6>
                  <strong style="font-size: 40px; color: #FB6058;">{{ exceedCETP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/8.png">
                </div>
              </div>
            </div>
          </div>

          <!-- CETP: Offline -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">No. of CETPs where CEMS is offline/Not functioning</h6>
                  <strong style="font-size: 40px; color: #814EC1;">{{ closeCETP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/3.png">
                </div>
              </div>
            </div>
          </div>

          <!-- CETP: Total waste water treated -->
          <div class="col-sm-6 col-md-4 col-lg-2-4">
            <div class="card card-list-item h-100 shadow-sm">
              <div class="card-body d-flex align-items-start">
                <div class="flex-grow-1 me-3">
                  <h6 class="mb-1 fw-semibold" style="font-size: 14px;">Total Waste Water treated through STPs of DJB (in MLD)</h6>
                  <strong style="font-size: 40px; color: #814EC1;">{{ waterCETP }}</strong>
                </div>
                <div class="flex-shrink-0">
                  <img src="/assets/images/icons/3.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Pie Charts Section with Card Layout -->
<div class="page-container" *ngIf="graphPlot">
  <div class="row mt-4 g-3">
    <div class="col-md-6">
      <div class="card shadow-sm h-100">
        <div class="card-body">
          <h6 class="fw-semibold card-title">STP Pie Chart</h6>
          <div [chart]="stpPieChart" style="height: 350px; min-width: 310px;"></div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card shadow-sm h-100">
        <div class="card-body">
          <h6 class="fw-semibold card-title">CETP Pie Chart</h6>
          <div [chart]="cetpPieChart" style="height: 350px; min-width: 310px;"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
